import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  constructor() {
  }

  updateJsonFormat(data) {
    return {
      meta: {
        copyright: 'Copyright 2017 Ekbana Pte',
        email: 'info@ekbana.com',
        api: {
          version: '1'
        }
      },
      data
    };
  }

}
